import type { Ref } from 'vue'
import type { GraphQLError, GraphQLFormattedError } from 'graphql'

export class ServerError extends Error {
  statusCode: number
  constructor(message: string, statusCode = 500) {
    super(message)
    this.statusCode = statusCode
    this.name = 'ServerError'
  }
}

export class NotFoundError extends ServerError {
  constructor(message: string) {
    super(message, 404)
  }
}

export function createAsyncDataError(error: Ref<Error | null>) {
  if (error.value) {
    return createError({
      statusCode:
        'statusCode' in error.value && typeof error.value.statusCode === 'number'
          ? error.value.statusCode
          : 500,
      message: error.value.message,
      fatal: true,
    })
  }
  return createError({ statusCode: 500, message: 'Server error', fatal: true })
}

export function createGraphQLError(
  errors: readonly GraphQLError[] | readonly GraphQLFormattedError[],
  customMessage?: string,
) {
  const message = errors.map((e) => e.message).join('; ')
  return Error(customMessage ? `${customMessage} -> ${message}` : message)
}
